const $ = require('jquery')

// ------------------------------------
// Scroll to element
// ------------------------------------
module.exports = function() {
  const fixedElemsHeight = $('header.header').outerHeight(true) + $('.main-search .container').outerHeight(true)

  $('a[href*=#]:not([href=#]):not([data-toggle])').on('click.smoothscroll', function() {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      let target = $(this.hash)
      target = target.length ? target : $(`.${this.hash.slice(1)}`)
      if (target.length) {
        target = target.offset().top - fixedElemsHeight
        $('html,body').animate({ scrollTop: target }, 600)
        return false
      }
    }
    return null
  })
}




// WEBPACK FOOTER //
// ./src/modules/smoothScroll.js